import { client } from './setup';
import { RECOVERY_API } from '../globals';

export default {
    forgotPassword: (account) => client.post(`${RECOVERY_API}/forgot-password`, account),
    resetPassword: (credentials) => client.post(`${RECOVERY_API}/reset-password`, credentials),
}